import axios from "axios";
import config from "../config";


const axiosInstance = axios.create({
    baseURL: config.aiApiUrl,
    timeout: 60000,
    headers: {
        "Content-Type": "application/json",
        accept: "application/json",
    }
})

const secretKey = process.env.REACT_APP_SECRET_KEY ? process.env.REACT_APP_SECRET_KEY : ""
const apiKey = process.env.REACT_APP_API_KEY ? process.env.REACT_APP_API_KEY : ""

// Adding API access keys to headers
axiosInstance.defaults.headers.common['HOMECOOK-SECRET-KEY'] = secretKey
axiosInstance.defaults.headers.common['HOMECOOK-API-KEY'] = apiKey



export const generateAIInsight = async (username: string, query: string) => {
    try {
        const response = await axiosInstance.post(`/knowledge_base/generate_insights`, {
            username,
            query
        })
        return response.data;
    } catch (error) {
        console.error('Error generating AI insight:', error);
        // throw error;
    }
}


// export const generateAIInsight = async (username: string, prompt: string) => {
//     const response = await axiosInstance.get(`/knowledge_base/generate_insights`, {
//         params: {
//             username,
//             prompt
//         }
//     })
//     return response.data;
// }



export default axiosInstance;